import React, { memo, useEffect, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import ChatListView from './components/ChatListView';
import { useTheme } from '../../hooks/useTheme';
import Search from './components/Search';
import WalletHistory from './wallet/WalletHistory';
import { SidebarMenu } from '../../components/SidebarMenu';
import FormEditProfile from './FormEditProfile';
import LineActiveCall from '../../components/LineActiveCall';

export const SidebarMain: React.FC = memo(() => {  
  const {isMobile} = useTheme();
  const location = useLocation();
  const {tab} = useParams();
  const [showChatListView, setShowChatListView] = useState(false);
  const [showOutlet, setShowOutlet] = useState(false);

  useEffect(() => {
    setShowChatListView(
      !isMobile || 
      location.pathname === '/home/chat' || 
      location.pathname === '/home/search' ||
      location.pathname === '/home/wallet' ||
      location.pathname === '/home/edit-profile'
    );

    let shouldShowOutlet = false;

    if(
      (!isMobile || location.pathname !== '/home/chat') && 
      location.pathname !== '/home/search' &&
      location.pathname !== '/home/wallet' &&
      location.pathname !== '/home/edit-profile'
    )
    {
      shouldShowOutlet = true;
    }

    setShowOutlet(shouldShowOutlet);
  }, [location, isMobile, tab]);

  const renderInside = () => {
    if(location.pathname.startsWith('/home/search')) {
      return <Search />;
    }

    if(location.pathname.startsWith('/home/chat')) {
      return <ChatListView />;
    }

    if(location.pathname.startsWith('/home/wallet')) {
      return <WalletHistory />;
    }

    if(location.pathname.startsWith('/home/edit-profile')) {
      return <FormEditProfile />;
    }
  }

  return (
    <div className="h-full safe-area-inset">
      <div className="flex flex-row align-stretch h-screen">
        {!isMobile && <SidebarMenu />}
        <div 
          className={`flex-shrink-0 bg-brand-bg-1 ${isMobile ? 'w-full' : 'w-[420px]'} ${showChatListView ? '' : 'hidden'}`}
        >
          <div className="flex flex-col h-full bg-brand-bg-2 rounded-l-3xl">
            {isMobile && <LineActiveCall />}
            {renderInside()}
          </div>
        </div>
        {
          showOutlet && (
            <div className={`flex-grow ${isMobile ? '' : 'py-4 pr-4 pl-4 overflow-hidden'}`}>
              <Outlet />
            </div>
          )
        }
      </div>
    </div>
  );
});

export default SidebarMain;